module.exports = __webpack_public_path__ + "images/img-1tdS-sc.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/7.png
// module id = 2343
// module chunks = 0